import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";

const PurchaseFilterForm = ({ onFilter }) => {
  const itemsList = useSelector((state) => state.inventory);
  const { itemsData = [], supplierData = [] } = itemsList || {};

  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("supplier"); // ✅ Default

  // Auto update Group when supplier changes
  useEffect(() => {
    if (selectedSupplier) {
      // Supplier selected → move to Category group
      if (selectedGroup === "supplier") setSelectedGroup("category");
    } else {
      // Supplier cleared → revert to default
      setSelectedGroup("supplier");
      setSelectedCategory("");
      setSelectedItem("");
    }
    // eslint-disable-next-line
  }, [selectedSupplier]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter({
      selectedGroup,
      supplierId: selectedSupplier,
      category: selectedCategory,
      item: selectedItem,
      fromDate,
      toDate,
    });
  };

  const handleReset = () => {
    setSelectedSupplier("");
    setSelectedItem("");
    setFromDate("");
    setSelectedCategory("");
    setToDate("");
    setSelectedGroup("supplier"); // ✅ Reset to original default

    onFilter({
      selectedGroup: "supplier",
      supplierId: "",
      item: "",
      category: "",
      fromDate: "",
      toDate: "",
    });
  };

  // Build Group Options Dynamically
  const groupOptions = [
    { label: "Supplier", value: "supplier" },
    { label: "Category", value: "category" },
    { label: "Item", value: "item" },
  ];

  // If supplier selected, remove "Supplier" from dropdown
  const filteredGroupOptions = selectedSupplier
    ? groupOptions.filter((g) => g.value !== "supplier")
    : groupOptions;

  return (
    <Form onSubmit={handleSubmit} className="mb-4">
      <FormGroup row>
        <Label for="Group" md={1} className="fw-bold pt-4">
          Group By
        </Label>
        <Col sm={3} md={3} className="pt-3">
          <Input
            className="custom-select-style"
            type="select"
            id="group"
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            disabled={selectedSupplier} // ✅ Lock when supplier selected
          >
            {filteredGroupOptions.map((g) => (
              <option key={g.value} value={g.value}>
                {g.label}
              </option>
            ))}
          </Input>
        </Col>

        <Label for="supplier" md={1} className="fw-bold pt-4">
          Supplier
        </Label>
        <Col sm={3} md={3} className="pt-3">
          <Input
            className="custom-select-style"
            type="select"
            id="supplier"
            value={selectedSupplier}
            onChange={(e) => setSelectedSupplier(e.target.value)}
          >
            <option value="">-- Select Supplier --</option>
            {supplierData.map((sup) => (
              <option key={sup.supplierId} value={sup.supplierId}>
                {sup.supplierName || sup.supplierId}
              </option>
            ))}
          </Input>
        </Col>

        <Label for="category" md={1} className="fw-bold pt-4">
          Category
        </Label>
        <Col sm={3} md={3} className="pt-3">
          <Input
            className="custom-select-style"
            type="select"
            name="category"
            id="category"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            disabled={selectedGroup !== "category"}
          >
            <option value="">Select option</option>
            <option value="Grocery / Provisions">Grocery / Provisions</option>
            <option value="Meat, Fish & Eggs">Meat, Fish & Eggs</option>
            <option value="Vegetables & Fruits">Vegetables & Fruits</option>
            <option value="Masalas">Masalas</option>
            <option value="Dairy & Bakery">Dairy & Bakery</option>
            <option value="Housekeeping & Consumables">Housekeeping & Consumables</option>
            <option value="Beverages">Beverages</option>
            <option value="Health & Wellness">Health & Wellness</option>
            <option value="Miscellaneous">Miscellaneous</option>
          </Input>
        </Col>

        <Label for="item" md={1} className="fw-bold pt-4">
          Item
        </Label>
        <Col sm={3} md={3} className="pt-3">
          <Input
            className="custom-select-style"
            type="select"
            id="item"
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
            disabled={selectedGroup !== "item"}
          >
            <option value="">-- Select Item --</option>
            {itemsData.map((item) => (
              <option key={item.productId} value={item.item}>
                {item.item}
              </option>
            ))}
          </Input>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="fromDate" md={1} className="fw-bold pt-4">
          From Date
        </Label>
        <Col sm={2} md={2} className="pt-3">
          <Input
            type="date"
            id="fromDate"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </Col>

        <Label for="toDate" md={1} className="fw-bold pt-4">
          To Date
        </Label>
        <Col sm={2} md={2} className="pt-3">
          <Input
            type="date"
            id="toDate"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </Col>

        <Col sm={3} md={3} className="pt-3">
          <Button color="primary" className="me-3" type="submit">
            🔍 Filter
          </Button>
          <Button color="secondary" type="button" onClick={handleReset} className="ms-2">
            ♻️ Reset
          </Button>
        </Col>
      </FormGroup>
    </Form>
  );
};

export default PurchaseFilterForm;
